import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { services } from '../data/content';
import { SectionLabel } from './SectionLabel';
export function Services() {
  return <section id="services" aria-labelledby="services-heading" className="w-full bg-warm py-20 lg:py-28" data-id="element-217" data-mp="1du0ww9sazw7t">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-218" data-mp="18v7txban7nlw">
        <div className="max-w-3xl" data-id="element-219" data-mp="18uocrwsth38x">
          <SectionLabel number="01" data-id="element-220" data-mp="13vl5e5pd6kxs">Services</SectionLabel>
          <h2 id="services-heading" className="mt-5 font-display text-[34px] font-semibold uppercase leading-[1.02] text-ink sm:text-[44px] lg:text-[54px]" data-id="element-221" data-mp="13x60bwflc5w6">
            The right perimeter starts with the right system.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-steel sm:text-lg" data-id="element-222" data-mp="q5hpdwh2vngs">
            Every site carries its own constraints — access, equipment, clearances and the
            specifications the project is held to. We work from your plans and requirements to
            install the fence, gate and protection systems that fit the site.
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3 lg:mt-16" data-id="element-223" data-mp="3b3pu15pn77dd">
          {services.map(service => <li key={service.title} className="flex flex-col overflow-hidden border-2 border-ink/30 bg-white shadow-[0_6px_18px_rgba(16,35,45,0.08)]" data-id="element-224" data-mp="2xcuhnjfxq851">
              <div className="relative aspect-[4/3] w-full overflow-hidden border-b-4 border-safety" data-id="element-225" data-mp="328i3bov7kj5s">
                <img src={service.image} alt={service.alt} width={service.width} height={service.height} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-226" data-mp="3u223kskguj9h" />
              </div>

              <div className="flex flex-1 flex-col p-6 lg:p-7" data-id="element-227" data-mp="24m2okuu61zlx">
                <h3 className="min-h-[2.6rem] font-display text-[27px] font-bold uppercase leading-tight text-ink" data-id="element-228" data-mp="29m770qemx4es">
                  {service.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-steel" data-id="element-229" data-mp="1pjb362xfcu5p">{service.body}</p>
                <ul className="mt-5 space-y-2 border-t border-steel-300 pt-5 text-[15px] leading-relaxed text-ink" data-id="element-230" data-mp="1ljal88b4a0tw">
                  {service.detail.map(item => <li key={item} className="flex gap-3" data-id="element-231" data-mp="1brmpvwbfvzn5">
                      <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 bg-safety" data-id="element-232" data-mp="16tl7zepr26d9" />
                      <span data-id="element-233" data-mp="11uhz1j6nfg00">{item}</span>
                    </li>)}
                </ul>
                <a href="#contact" className="mt-auto inline-flex min-h-[44px] items-center gap-2 pt-7 font-display text-[17px] uppercase tracking-[0.08em] text-ink transition-colors duration-150 ease-industrial hover:text-steel" data-id="element-234" data-mp="xswoi4hl7dsz">
                  {service.cta}
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4 text-safety-600" data-id="element-235" data-mp="2n7bees4cd6q2" />
                </a>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}